export enum PokerType {
  UNKNOWN = 0,
  TEXASHOLDEM = 100,
  OMAHAHI = 102,
  OMAHAHILO = 104,
}
